<template>
  <div class="nx-scrollytelling-field">
    <nx-scrollytelling-slide-list :value="value"
                                  disabled
                                  @create="handleCreate"
                                  @move="handleMove"
                                  @edit="handleEdit"/>
    <nx-scrollytelling-slide-editor ref="editor"
                                    :active="openEditor"
                                    :value="value"
                                    :preview-url="previewUrl"
                                    :loading="loading"
                                    @input="handleInput"
                                    @dismiss="openEditor = false" />
  </div>
</template>

<script>
import NxScrollytellingSlideEditor from '@/modules/scrollytelling/components/ScrollytellingSlideEditor';
import NxScrollytellingSlideList from '@/modules/scrollytelling/components/ScrollytellingSlideList';

export default {
  name: 'nx-scrollytelling-field',
  components: {
    NxScrollytellingSlideList,
    NxScrollytellingSlideEditor,
  },
  props: {
    previewUrl: {
      type: String,
      required: true,
    },
    loading: {
      type: Boolean,
    },
    value: {
      type: Array,
      default: () => ([]),
    },
  },
  data() {
    return {
      openEditor: false,
    };
  },
  methods: {
    handleCreate() {
      this.$refs.editor.setWizardView();
      this.openEditor = true;
    },
    async handleEdit({ slide, index }) {
      await this.$store.dispatch('scrollytelling/SET_SLIDE_ID_BEING_EDITED', slide.uuid);
      await this.$refs.editor.editSlide({ slide, index });
      this.openEditor = true;
    },
    handleInput(value) {
      this.$emit('input', value);
    },
    handleMove(value) {
      this.$emit('move', value);
    },
  },
};
</script>
